// extracted by mini-css-extract-plugin
export default {"InWorkStatus":"StatusCard_InWorkStatus__BDLdo","NeedHelpStatus":"StatusCard_NeedHelpStatus__50Ir0","DoneStatus":"StatusCard_DoneStatus__iEvZa"};